import { PageRef } from 'providers/page-ref';

export type EditWeighInPageParams = {
  id: string;
  day: string;
};

export const IEditWeighInPage: PageRef<EditWeighInPageParams, void> = {
  pageName: 'EditWeighInPage',
} as PageRef<EditWeighInPageParams, void>;
